/**
 * Tenant master settings API client (BFF: `/api/v1/store/settings/tenant`).
 *
 * Sales mode, locale/currency defaults and feature flags (→ web-tenant-settings-service).
 */
import { apiClient } from '@/shared/api';
import type { TenantSettings, UpdateTenantSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/tenant';

export const getTenantSettings = async (): Promise<TenantSettings> =>
  (await apiClient.get<TenantSettings>(BASE)).data;

export const updateTenantSettings = async (
  body: UpdateTenantSettingsRequest,
): Promise<TenantSettings> => (await apiClient.put<TenantSettings>(BASE, body)).data;
